/**
 * Helpers puros da Ordem de Retirada (testados em goodsPickupOrderUtils.test.ts).
 */
import type { GoodsPickupOrder } from '@/types/goodsPickupOrder';

export type PickupOrderStatus = 'pending' | 'delivered' | 'canceled';

/** Cancelada tem precedência (o backend não deixa entregar nem cancelar de novo). */
export const pickupOrderStatus = (
  order: Pick<GoodsPickupOrder, 'is_delivered' | 'is_canceled'>,
): PickupOrderStatus => {
  if (order.is_canceled) return 'canceled';
  if (order.is_delivered) return 'delivered';
  return 'pending';
};

export const PICKUP_ORDER_STATUS_LABELS: Record<PickupOrderStatus, string> = {
  pending: 'Pendente',
  delivered: 'Entregue',
  canceled: 'Cancelada',
};

export const pickupOrderStatusBadge = (status: PickupOrderStatus): 'warning' | 'success' | 'neutral' => {
  switch (status) {
    case 'pending':
      return 'warning';
    case 'delivered':
      return 'success';
    case 'canceled':
      return 'neutral';
  }
};
